module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Usuários")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row collapse in",
    staticStyle: {
      "width": "inherit",
      "height": "auto"
    },
    attrs: {
      "aria-expanded": "true",
      "aria-hidden": "false"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid ng-valid-mask ng-valid-maxlength ng-valid-date",
    attrs: {
      "name": "frmSearch",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "userType"
    }
  }, [_vm._v("Tipo de usuário:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.userType),
      expression: "filtros.userType"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "name": "userType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "userType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(this.$root.authorize('usuario-entidade-visualizar')) ? _c('option', {
    staticClass: "ng-scope",
    attrs: {
      "value": ""
    }
  }) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-entidade-visualizar')) ? _c('option', {
    staticClass: "ng-scope",
    attrs: {
      "value": "ENTIDADE"
    }
  }, [_vm._v("Entidade")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-agencia-visualizar')) ? _c('option', {
    staticClass: "ng-scope",
    attrs: {
      "value": "AGENCIA"
    }
  }, [_vm._v("Agência")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-estrategico-visualizar')) ? _c('option', {
    staticClass: "ng-scope",
    attrs: {
      "value": "PARCEIRO_ESTRATEGICO"
    }
  }, [_vm._v("Parceiro estratégico")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-superintendencia-visualizar')) ? _c('option', {
    staticClass: "ng-scope",
    attrs: {
      "value": "SUPERINTENDENCIA"
    }
  }, [_vm._v("Superintendência")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-fundacao-visualizar')) ? _c('option', {
    staticClass: "ng-scope",
    attrs: {
      "value": "FUNDACAO"
    }
  }, [_vm._v("Fundação")]) : _vm._e()])]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-sm-1",
    attrs: {
      "for": "login"
    }
  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.login),
      expression: "filtros.login"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "name": "login",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.filtros.login)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "login", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-sm-1",
    attrs: {
      "for": "profiles"
    }
  }, [_vm._v("Perfil:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('profiles', {
    attrs: {
      "propsProfile": _vm.filtros.profile
    },
    on: {
      "profileSelected": function($event) {
        _vm.filtros.profile = $event
      }
    },
    model: {
      value: (_vm.filtros.profile),
      callback: function($$v) {
        _vm.$set(_vm.filtros, "profile", $$v)
      },
      expression: "filtros.profile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.name),
      expression: "filtros.name"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.name)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-sm-1",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.email),
      expression: "filtros.email"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "name": "email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.email)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-sm-1",
    attrs: {
      "for": "createdAt"
    }
  }, [_vm._v("Data de inclusão:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.createdAt),
      expression: "filtros.createdAt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.createdAt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "createdAt", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 "
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.active),
      expression: "filtros.active"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "? undefined:undefined ?"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Ativa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Inativa")])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "btn-group dropdown"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "dark-primary",
      "size": "button--size-ss",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Novo Usuário ")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(this.$root.authorize('usuario-agencia-novo')) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-entidade-novo')) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-estrategico-novo')) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (this.$root.authorize('usuario-superintendencia-novo')) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_vm._m(4)]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "dark-primary",
      "size": "button--size-ss",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Pesquisar\n                ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onCleanSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar\n                ")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.items,
      "hover": _vm.hover,
      "fields": _vm.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Preencha o filtro acima!",
      "table-layout:": "",
      "fixed": ""
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "active",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value == 'true' ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }, {
      key: "createdAt",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'cadastro-usuarios-edita',
                params: row.item
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  Editar")]), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "warning",
            "size": "button--size-ss",
            "disabled": !_vm.authorizeDeleteUser(row.item)
          },
          nativeOn: {
            "click": function($event) {
              return _vm.inativa(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.item.active === 'true' ? ' Inativar' : ' Ativar'))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Consulta de Usuários")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "ng-click": "onNew('AGENCIA')",
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Agência")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "ng-click": "onNew('ENTIDADE')",
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Entidade")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "ng-click": "onNew('PARCEIRO_ESTRATEGICO')",
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Parceiro Estratégico")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "ng-click": "onNew('SUPERINTENDENCIA')",
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Superintendência")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4915fdbf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/usuario/ListaUsuarios_old.vue
// module id = 1939
// module chunks = 1